import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
	providedIn: 'root'
})
export class ToastService {

	public toastButtons = [
		{
		  text: 'Luk',
		  role: 'cancel'
		},
	  ];

	// ---- Constructor ---- \\
	constructor(
		private toastController: ToastController
	) { }



	// ---- Methods ---- \\

	/**
	 * Present a toast with given message
	 * 
	 * @param message message you want to display
	 * @param color "primary", "secondary", "tertiary", "success", "warning", "danger", "light", "medium", and "dark"
	 */
	public async presentToast(
		message: string, 
		color: 'primary' | 'secondary' | 'tertiary' | 'success' | 'warning' | 'danger' | 'light' | 'medium' | 'dark' = 'primary', 
		duration: number = 5000, 
		position: 'top' | 'bottom' | 'middle' = 'top'
	) {
		const buttons = color === 'danger' ? this.toastButtons : [];
		const icon = (color === 'danger' || color === 'warning') ? 'alert-outline' : 'checkmark-outline';

		const toast = await this.toastController.create({
			icon,
			duration: color === 'danger' ? undefined : duration,
			position,
			message,
			color,
			buttons
		});

		toast.present();
	}
}
